import * as plugins from "./plugins.js";
import * as woocommerce from "./woocommerce.js";

jQuery(window).on("load", function () {
  console.log("main running");
  plugins.init();
  woocommerce.init();
  
});
